// extracted by css-extract-rspack-plugin
export default {"right":"Right_right__EHXew","infoIcon":"Right_infoIcon__e7O40"};